<template>
  <div>
  <page-title :heading=heading icon='far fa-file-alt fa-fw icon-color'></page-title>
    <v-container style="max-width: 100%;">
      <v-layout>
        <v-flex class="text-xs-center" sm2>
          <v-menu v-model="menuP" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="startDate" :rules="rules.required" :label="$t('expenses.filter.startDate')" prepend-icon="event" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker color="primary" :max="finishDate" v-model="startDate" @input="menu = false" :locale="$t('reportsByConcept.local')"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex class="text-xs-center" sm2>
          <v-menu v-model="menuP2" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="finishDate" :rules="rules.required" :label="$t('expenses.filter.endDate')" prepend-icon="event" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker color="primary" v-model="finishDate" @input="menu2 = false" :max="new Date().toISOString().substr(0, 10)" :min="startDate" :locale="$t('reportsByConcept.local')"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex>
          <v-btn color="primary" round outline @click="search" :loading="loadingDownload">
            <v-icon left>search</v-icon> {{$t('general.search')}}
          </v-btn>
        </v-flex>
        <v-flex class="text-sm-right">
          <v-text-field v-model="searchReport" :label="$t('general.search')" clearable append-outer-icon="search"></v-text-field>
        </v-flex>
        <v-flex class='text-sm-right' sm1>
          <v-btn color="primary" round outline @click="downloadReport()" :loading="loadingDownload">
            {{$t('general.report')}}<v-icon right>get_app</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout v-if="loadingItems">
        <v-flex>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
          <span>{{$t('general.loadingText')}}</span>
        </v-flex>
      </v-layout>
      <v-layout v-if="show && !loadingItems" >
        <v-flex class="flex-table-container">
          <v-data-table
            :search="searchReport"
            :headers="header"
            :items="dataCategoryBranch"
            :loading="loadingItems"
            hide-actions
            :custom-filter="filterOnlyCapsText"
            :no-data-text="$t('expenseDetailEmployee.noResults')">
            <template v-slot:no-data v-if="dataCategoryBranch.length > 0">
              <center class="subtitle font-weight-light">{{$t('general.noDataText')}}</center>
            </template>
            <template v-slot:headers="props">
              <tr class="bg-heavy-rain header-sticky"  style="height: 35px !important;">
                <th v-for="header in props.headers" :class="['column']" :key="header.text">
                  <h2 class="font-weight-black primary--text mb-0">{{header.text}}</h2>
                </th>
              </tr>
              <tr class="header-sticky" style="height: 30px !important;">
                <td v-for="(branch, index) in totalFooter" :key="`${branch}-${index}`" class="text-xs-center">
                  <b v-if="branch === $t('general.total')">{{ $t('general.alls') }}</b>
                  <b v-else>{{ branch | formatCurrency }} </b>
                </td>
              </tr>
            </template>
            <template v-slot:items="props">
              <td v-for="(branch, index) in header" :key="`${branch.text}-${index}`" class="text-xs-center" style="height: 30px !important;">
                <span v-if="branch.text === $t('general.category')"> <b>{{ props.item.category }}</b></span>
                <span v-else-if="branch.text === $t('general.total')"><b>{{ props.item.total | formatCurrency}}</b></span>
                <span v-else>{{ props.item[branch.text] | formatCurrency }}</span>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
     </v-container>
  </div>
</template>

<script>
export default {
  name: 'reportExpensesCategoryBranchComponent',
  data () {
    return {
      searchReport: '',
      loading: false,
      loadingItems: true,
      companyId: null,
      userLogged: {},
      itemsTable: [],
      url: '',
      show: false,
      branches: [],
      menuP: false,
      menuP2: false,
      startDate: new Date().toISOString().substr(0, 8) + '01',
      finishDate: new Date().toISOString().substr(0, 10),
      headerDynamic: [],
      totalFooter: [],
      loadingDownload: false
    }
  },
  watch: {
    '$store.state.userLogged' () {
      this.getLogged()
    }
  },
  created () {
    this.getLogged()
  },
  methods: {
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
        this.companyId = this.userLogged.company[0].id
        this.getBranches()
        this.search()
      }
    },
    getBranches () {
      this.$emit('getBranches', {
        context: this,
        item: {
          companyId: this.companyId
        }
      })
    },
    close () {
      this.dialog = false
    },
    search () {
      this.loadingItems = true
      this.url = `${this.companyId}/${this.startDate}/${this.finishDate}?type=json`
      this.getReport()
    },
    getReport () {
      this.loadingDownload = true
      this.$emit('getReport', {
        context: this,
        item: {
          url: this.url
        }
      })
    },
    downloadReport () {
      this.loadingDownload = true
      var downloadUrl = this.url.replace('json', 'download')
      this.$emit('downloadReport', {
        context: this,
        item: {
          url: downloadUrl
        }
      })
    },
    filterOnlyCapsText (items, query) {
      if (!query) return items

      query = query.toLocaleUpperCase()

      return items.filter(item => {
        const category = item.category ? item.category.toString().toLocaleUpperCase() : ''
        return category.includes(query)
      })
    }
  },
  computed: {
    dataCategoryBranch () {
      if (this.branches.length === 0 || this.itemsTable.length === 0 || this.header.length === 0) return []

      const branches = [...new Set(this.branches.map(item => item.branch_name))]
      const uniqueCategories = [...new Set(this.itemsTable.map(item => item.category_name))]
      const uniqueBranches = branches
      // const uniqueBranches = branches.map(branch => branch.replace(/\s+/g, '_'))
      // No entiendo por qué se reemplazan los espacios por guiones bajos.

      // Paso 2: Construir la tabla de montos por categoría y sucursal
      const table = uniqueCategories.map(category => {
        const row = { category, total: 0 }

        uniqueBranches.forEach(branch => {
          const item = this.itemsTable.find(d => d.category_name === category && d.branch_name === branch)
          row[branch] = item ? parseFloat(item.total) : 0
          row.total += row[branch] // Sumar al total de la categoría
        })

        return row
      })

      // // Paso 3: Calcular el total por sucursal y el total general
      const totals = { category: 'Total', total: 0 }
      uniqueBranches.forEach(branch => {
        totals[branch] = table.reduce((sum, row) => sum + row[branch], 0)
        totals.total += totals[branch]
      })

      const orderedTotals = { category: totals.category }

      uniqueBranches.forEach(branch => {
        if (totals.hasOwnProperty(branch)) {
          orderedTotals[branch] = totals[branch]
        }
      })

      orderedTotals.total = totals.total
      this.totalFooter = orderedTotals

      return table
    },
    heading () {
      return this.$t('reports.reportExpensesCategoryBranch')
    },
    header () {
      if (!this.branches.length > 0) return []

      const branchColumns = this.branches.map((branchName, index) => ({
        text: branchName.branch_name,
        value: `${branchName}`,
        align: 'center',
        class: 'font-weight-black white--text column primary'
      }))

      branchColumns.push({
        text: this.$t('general.total'),
        value: 'Total',
        align: 'center',
        class: 'font-weight-black white--text column primary'
      })

      branchColumns.unshift({
        text: this.$t('general.category'),
        value: 'name',
        align: 'center',
        class: 'font-weight-black white--text column primary'
      })
      return branchColumns
    },
    rules () {
      return {
        yearRules: [
          v => (v && v.length >= 4) || this.$t('validation.minNumberDigits', {number: 4})
        ]
      }
    }
  }
}
</script>

<style scoped>
.header-sticky {
  position: sticky !important;
  top: 0 !important; /* Ajusta esto según la posición de tu barra de navegación si es necesario */
  z-index: 100; /* Asegúrate de que esté por encima del contenido */
  background-color: #f7f9fa  !important; /* Color de fondo para la cabecera */
}

.flex-table-container {
  max-height: 500px; /* Altura fija para el scroll */
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/reportExpensesCategoryBranch.component.vue